import { createFileRoute } from '@tanstack/react-router'
import { SupplierRefundsListPage } from '../../../features/purchasing/refunds-list-page'
import { supplierRefundSearchSchema } from '../../../features/purchasing/search'

export const Route = createFileRoute('/_app/supplier-refunds/')({
  validateSearch: supplierRefundSearchSchema,
  component: SupplierRefundsListPage,
})
